//#region [IMPORT]

import React, { createContext, useContext, useEffect, useState } from "react";
import { connect, on, removeListener, sendMessageData } from "api/prokey/prokey.websocket";

//#endregion

//#region [VALUES]

const ContextSession = createContext()

//#endregion

export const OnlineStatus = Object.freeze({
  DEFAULT        : 0,
  CONNECTED      : 1,
  DISCONNECTED   : 2,
  RECONNECTING   : 3,
  RECONNECT_FAIL : 4,
})

//-----------------------------------------------------------------
export function SessionProvider( { children } ) {
  //-----------------------------------------------------------------
  //#region [VALUES]

  const [ user_details , setUserDetails  ] = useState( { roles: [] } );
  const [ online_status, setOnlineStatus ] = useState( OnlineStatus.DEFAULT );

  //#endregion

  //#region [EFFECT]
  
  useEffect( () => {
    //-----------------------------------------------------------------
    function _handleUserDetails( data ) {
      //-----------------------------------------------------------------
      data.display_name =  `${data.FirstName} ${data.LastName} (${data.Username})`;
      data.initials = 
        data.FirstName.substring( 0, 1 )
      + data.LastName .substring( 0, 1 );

      setUserDetails( data );
    }

    on( 'USER_DETAILS', _handleUserDetails );

    return () => {
      removeListener( 'USER_DETAILS', _handleUserDetails );
    }
  }, [] );
  
  useEffect( () => {

    //-----------------------------------------------------------------
    function handleDisconnect() {
      //-----------------------------------------------------------------
      setOnlineStatus( OnlineStatus.DISCONNECTED );
    }

    //-----------------------------------------------------------------
    function handleReconnect() {
      //-----------------------------------------------------------------
      setOnlineStatus( OnlineStatus.RECONNECTING );
    }

    //-----------------------------------------------------------------
    function handleReconnectFail() {
      //-----------------------------------------------------------------
      setOnlineStatus( OnlineStatus.RECONNECT_FAIL );
    }

    //-----------------------------------------------------------------
    function handleConnection() {
      //-----------------------------------------------------------------
      setOnlineStatus( OnlineStatus.CONNECTED );
      sendMessageData( 'USER_DETAILS_REQUEST' );
    }

    on(  'disconnection', handleDisconnect    );
    on(   'reconnection', handleReconnect     );
    on( 'reconnect-fail', handleReconnectFail );
    on(     'connection', handleConnection    );

    connect();

    return () => {
      removeListener(  'disconnection', handleDisconnect    );
      removeListener(   'reconnection', handleReconnect     );
      removeListener( 'reconnect-fail', handleReconnectFail );
      removeListener(     'connection', handleConnection    );
    }

  }, [] );

  //#endregion

  return (
    <ContextSession.Provider value={ {user_details, online_status} }>
      {children}
    </ContextSession.Provider>
  );
};

//-----------------------------------------------------------------
export function useSession() {
  //-----------------------------------------------------------------
  return useContext( ContextSession );
}